// ─────────────────────────────────────────────────────────────────────
// /workflows — launcher page of the sidebar's "Time, FTO & COA" entry (owner 2026-10-06;
// it was "General SS White" with every module). Renders the MenuHub component which
// handles the 2-level drill-down (workflow cards → sub-action cards); the other modules'
// hub pages (/workflows?wf=<key>) are opened from the department pages.
// ─────────────────────────────────────────────────────────────────────
import React from "react";
import { Container } from "reactstrap";
import MenuHub, { HUB_NAME } from "../../Components/Common/MenuHub";

const WorkflowsLauncher = () => {
    document.title = `${HUB_NAME} | SSW Technologies`;
    return (
        <div className="page-content">
            <Container fluid>
                <MenuHub />
            </Container>
        </div>
    );
};

export default WorkflowsLauncher;
